module.exports = __webpack_public_path__ + "static/media/terms_en.85a13708.md";